import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHardwareNuts = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "hardware-nuts" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.644,14.25H5.75A1.5,1.5,0,0,1,4.5,13.582L1,8.332A1.5,1.5,0,0,1,1,6.668l3.5-5.25A1.5,1.5,0,0,1,5.75.75h5.894a1.5,1.5,0,0,1,1.248.668l3.5,5.25a1.5,1.5,0,0,1,0,1.664l-3.5,5.25A1.5,1.5,0,0,1,11.644,14.25Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 8.697,
			cy: 7.5,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.25,9.75a1.5,1.5,0,0,1,1.248.668l3.5,5.25a1.5,1.5,0,0,1,0,1.664l-3.5,5.25a1.5,1.5,0,0,1-1.248.668H12.355a1.5,1.5,0,0,1-1.248-.668l-3.5-5.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.3,14.25a2.25,2.25,0,1,1-2.25,2.25"
		})
	]
});
export default SvgHardwareNuts;
